export const settingsSections = [
  "whatsapp",
  "ninjaone",
  "queues",
  "companies",
  "templates",
  "automation",
  "surveys",
  "productivity",
  "technical",
  "administration",
  "login-editor"
] as const;

export type SettingsSection = (typeof settingsSections)[number];

export const settingsSectionPermissions: Record<SettingsSection, Permission> = {
  whatsapp: "integrations.manage", ninjaone: "integrations.personal", queues: "queues.manage",
  companies: "companies.manage", templates: "templates.manage", automation: "settings.global",
  surveys: "surveys.manage", productivity: "productivity.manage", technical: "settings.diagnostics",
  administration: "admin.users", "login-editor": "login.editor"
};

export function canAccessSettingsSection(user: { role: UserRole } | null | undefined, section: SettingsSection) {
  return hasPermission(user, settingsSectionPermissions[section]);
}

export function activeSettingsSectionFromHash(hash: string): SettingsSection {
  const section = hash.replace(/^#/, "");
  return settingsSections.find((item) => item === section) ?? "whatsapp";
}
import { hasPermission, type Permission, type UserRole } from "@htzap/contracts";
